
    try {
        if (window.navigator && navigator.serviceWorker) {
            navigator.serviceWorker.getRegistrations()
                .then(function (registrations) {
                    for (let registration of registrations) {
                        //if (registration.scope.includes(window.location.origin))
                        registration.unregister().catch(function (e) {
                            console.warn("Could not unregister service worker", e);
                        });
                        console.log("Service Worker unregistered " + registration);
                    }
                })
                // rejects with InvalidStateError when the browser's Service Worker system is shutting down
                .catch(function (e) {
                    console.warn("Could not get service worker registrations", e);
                });
        }
        if (window.localStorage.getItem('oidc.login.default'))
            window.localStorage.removeItem('oidc.login.default')
        if (window.localStorage.getItem('oidc.server:https://connect.identity.stagaws.visma.com'))
            window.localStorage.removeItem('oidc.server:https://connect.identity.stagaws.visma.com')
        if (window.localStorage.getItem('oidc.server:https://connect.visma.com'))
            window.localStorage.removeItem('oidc.server:https://connect.visma.com')
    } catch (e) {
        console.error("Error unregistering service workers", e);
    }

    if (window.caches) {
        window.caches.keys().then(function (cacheNames) {
            cacheNames.forEach(function (cacheName) {
                window.caches.delete(cacheName).catch(function (e) {
                    console.warn("Could not delete cache " + cacheName, e);
                });
            });
        }).catch(function (e) {
            console.warn("Could not clear caches", e);
        });
    }
